import { render, staticRenderFns } from "./DashboardMarketplace.vue?vue&type=template&id=b72ed864"
import script from "./DashboardMarketplace.vue?vue&type=script&lang=ts"
export * from "./DashboardMarketplace.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b72ed864')) {
      api.createRecord('b72ed864', component.options)
    } else {
      api.reload('b72ed864', component.options)
    }
    module.hot.accept("./DashboardMarketplace.vue?vue&type=template&id=b72ed864", function () {
      api.rerender('b72ed864', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dashboard/cards/DashboardMarketplace.vue"
export default component.exports